<template>
  <end-time v-if="end_time && is_last" @next="next" />

  <div v-else-if="loaded || showed" v-show="isShowContent" class="questions_one" :class="{ 'is-blurred': isBlurred }">
    <vtake-interval-photos
      :disabled="!hasAnticheating"
      allow-pass
      screen-by-start
      @set_photo="set_photo"
      @on_error="screenshots_error"
    >
      <template v-if="!is_separate_page" slot="enabled">
        <floating-block class-name="timer" @changeFixed="fixedTimer = $event">
          <timer
            questions="one"
            :inited="time_inited"
            :current="time_current"
            :number-of-question="q_num"
            :count-questions="questions.length"
            :stop_time="stop_time"
            @end_time="timeout"
          >
            <div v-if="fixedTimer && test.company && !!test.company.logo" class="logo">
              <img :src="test.company.logo" alt="vcv" />
            </div>

            <span v-else class="timer-label">{{ $tr('interview.tests.one.questions.timer') }}</span>
          </timer>
        </floating-block>

        <div class="text">
          <div v-if="question.is_graph_enabled && question.chart_config.length > 0" class="questions_one__charts">
            <div v-for="(config, indexChart) in question.chart_config" :key="indexChart" class="questions_one__chart">
              <apexchart
                :type="config.type"
                :series="configSeries(config.series)"
                :options="getApexOptions({ questionId: question.id, indexChart })"
                class="questions_one__chart"
              />
            </div>
          </div>

          <div v-if="media && is_media_visible">
            <question-media
              :media="media"
              :is_separate_page="!!time_inited"
              :is_disabled="!!time_inited"
              @stop_timer="stop_timer"
              @start_timer="start_timer"
              @start_media="start_media"
              @end="end_question_media"
            />
          </div>

          <div class="question_header" v-html="question.body"></div>

          <component
            :is="question.type"
            :index="q_num"
            :is-disabled="isTimeout"
            :token="token"
            :is_answer_paste_disabled="is_answer_paste_disabled"
            :data="question.answers"
            @update="update_answer"
          />
        </div>

        <div class="but-wrapper">
          <vbutton
            class="but"
            :text="text_for_button"
            :disabled="!can_save || loading"
            :loading="loading"
            @click="isTimeout ? next() : save()"
          />
        </div>
      </template>

      <template v-else slot="enabled">
        <div v-if="!show_question_content" class="text">
          <floating-block class-name="timer" @changeFixed="fixedTimer = $event">
            <div class="floating-flex">
              <timer
                questions="one"
                is_no_countdown
                :number-of-question="q_num"
                :count-questions="questions.length"
                :stop_time="stop_time"
              >
                <div v-if="fixedTimer && test.company && !!test.company.logo" class="logo">
                  <img :src="test.company.logo" alt="vcv" />
                </div>

                <span v-else class="timer-label">{{ $tr('interview.tests.one.questions.timer') }}</span>
              </timer>
              <div class="block-note">
                {{
                  is_audio
                    ? $tr('interview.tests.media.listen_audio_once')
                    : $tr('interview.tests.media.show_video_once')
                }}
              </div>
            </div>
          </floating-block>

          <div v-if="media && is_media_visible">
            <question-media
              :media="media"
              :is_separate_page="is_separate_page"
              :is_disabled="stop_next"
              @stop_timer="stop_timer"
              @start_timer="start_timer"
              @start_media="start_media"
              @end="btn_next"
            />
          </div>

          <div class="but-wrapper">
            <vbutton
              class="but"
              :label="'interview.bcg-test.passing.next'"
              :disabled="!stop_next"
              :loading="loading"
              @click="end_question_media"
            />
          </div>
        </div>

        <div v-else class="text">
          <floating-block class-name="timer" @changeFixed="fixedTimer = $event">
            <timer
              questions="one"
              :inited="time_inited"
              :current="time_current"
              :number-of-question="q_num"
              :count-questions="questions.length"
              @end_time="timeout"
            >
              <div v-if="fixedTimer && test.company && !!test.company.logo" class="logo">
                <img :src="test.company.logo" alt="vcv" />
              </div>

              <span v-else class="timer-label">
                {{ $tr('interview.tests.one.questions.timer') }}
              </span>
            </timer>
          </floating-block>

          <div class="text">
            <div class="question_header" v-html="question.body"></div>

            <component
              :is="question.type"
              :is-disabled="isTimeout"
              :token="token"
              :index="q_num"
              :is_answer_paste_disabled="is_answer_paste_disabled"
              :data="question.answers"
              @update="update_answer"
              @on-loading="set_loading"
            />
          </div>

          <div class="but-wrapper">
            <vbutton
              class="but"
              :text="text_for_button"
              :disabled="!can_save || loading"
              :loading="loading"
              @click="isTimeout ? next() : save()"
            />
          </div>
        </div>
      </template>
    </vtake-interval-photos>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import { dataURItoBlob } from '@/_helpers/utils.js';
import { STORE_PREFIX } from '../../constants.js';
import choice from './answers_choice';
import multichoice from './answers_multichoice';
import value from './answers_value';
import file from './answers_file';
import timer from './timer';
import EndTime from './end_time';
import QuestionMedia from './question_media';
import FloatingBlock from '@/components_new/floating-block';
import ScreenshotsProhibit from '@/mixins/ScreenshotsProhibit.js';

export default {
  name: 'QuestionsOne',

  components: {
    FloatingBlock,
    EndTime,
    value,
    file,
    choice,
    multichoice,
    timer,
    QuestionMedia
  },

  mixins: [ScreenshotsProhibit],

  props: ['test', 'hasAnticheating', 'isQuestionsOne'],

  data() {
    return {
      can_save: false,
      end_time: false,
      fixedTimer: false,
      show_question_content: false,
      is_media_visible: false,
      stop_next: false,
      stop_time: false,
      isTimeout: false
    };
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'test', {
      question_id: 'questions/current_opened_id',
      question: 'question/item',
      questions: 'questions/list',
      loaded: 'question/loaded',
      showed: 'question/showed',
      loading: 'questions/loading',
      token: 'token'
    }),

    ...mapGetters('questions', ['getApexOptions', 'getQuestionIndex']),

    q_num() {
      return this.questions && this.question ? this.questions.map(i => i.id).indexOf(this.question.id) + 1 : 0;
    },

    is_last() {
      return this.q_num === this.questions.length;
    },

    time_current() {
      return this.question ? this.question.remaining_time : null;
    },

    time_inited() {
      return this.question ? this.question.time_limit : null;
    },

    time_expired() {
      return this.question ? this.question.is_expired : false;
    },

    text_for_button() {
      if (this.is_last) {
        return this.$tr('interview.tests.one.questions.button.end');
      } else {
        return this.$tr('interview.tests.one.questions.button.next');
      }
    },

    is_answer_paste_disabled() {
      return this.test.is_answer_paste_disabled;
    },

    media() {
      return this.question ? this.question.media : null;
    },

    is_audio() {
      if (!this.media) {
        return false;
      }
      return this.media.type === 'audio';
    },

    is_separate_page() {
      if (!this.media) {
        return false;
      }
      return this.media.is_separate_page;
    }
  },

  watch: {
    question_id: {
      immediate: true,
      handler() {
        this.is_media_visible = false;
        this.show_question_content = false;
        setTimeout(() => {
          this.is_media_visible = true;
        }, 1000);
      }
    },

    can_save(val) {
      if (val) {
        window.onbeforeunload = function (e) {
          return e;
        };
      } else {
        window.onbeforeunload = null;
      }
    }
  },

  created() {
    let item = this.questions.find(i => i.id === this.question_id);

    if (this.questions && this.questions.length && !item) {
      this.$emit('end');
      return;
    }

    if (item.media && item.media.is_separate_page && !item.media.is_blocked) {
      this.show_media();
    } else if (item.media && item.media.is_blocked) {
      this.save();
    } else {
      this.load_question();
    }
  },

  mounted() {
    this.set_loading(false);
  },

  methods: {
    ...mapMutations(STORE_PREFIX + 'test/questions', ['set_loading']),

    configSeries(series) {
      return series.map(x => {
        if (x.data === undefined) {
          return Number(x);
        } else {
          return x;
        }
      });
    },

    load_question() {
      this.can_save = false;
      this.isTimeout = false;
      this.$store.dispatch(STORE_PREFIX + 'test/question/load', this.question_id);
    },

    show_media() {
      this.can_save = false;
      this.isTimeout = false;
      this.$store.dispatch(STORE_PREFIX + 'test/question/show_media', this.question_id);
    },

    update_answer(v) {
      this.set_loading(true);

      if (this.question.type === 'file' && v === 'reset') {
        this.set_loading(false);
        this.can_save = false;
        return;
      }
      if (this.question.type === 'file' && v && v[0].body && v[0].body.length > 0) {
        this.can_save = true;
        this.$store.commit(STORE_PREFIX + 'test/questions/update_candidate_answers', { id: this.question_id, v });
        this.set_loading(false);
      }
      if (this.question.type !== 'file') {
        this.can_save = true;
        this.$store.commit(STORE_PREFIX + 'test/questions/update_candidate_answers', { id: this.question_id, v });
        this.set_loading(false);
      }
    },

    screenshots_error() {
      this.$emit('screenshots_error');
    },

    next() {
      if (this.is_last && this.end_time) {
        return;
      }
      if (this.is_last && !this.end_time) {
        this.$emit('end');
        this.end_time = false;
      } else {
        // this.load_question();
        const item = this.questions.find(i => i.id === this.question_id);

        if (this.questions && this.questions.length && !item) {
          this.$emit('end');
          return;
        }
        if (item && item.media && item.media.is_separate_page) {
          this.show_media();
        } else {
          this.load_question();
        }
        // this.show_media();
        this.show_question_content = false;
        this.end_time = false;
      }
    },

    save(isTimeout = false) {
      if (this.loading) {
        this.next();
      }
      this.$store
        .dispatch(STORE_PREFIX + 'test/questions/save', {
          prefix: STORE_PREFIX
        })
        .then(() => {
          this.$store.commit(STORE_PREFIX + 'test/questions/set_answered', {
            id: this.question_id,
            v: true
          });

          if (this.is_last && isTimeout) {
            this.end_time = true;
          }
          this.next();
        })
        .catch(err => {
          const e = err.data && err.data.meta && err.data.meta.error ? err.data.meta.error.message : err;
          if (e === 'Response test question is expired') {
            this.next();
          }
        });
    },

    async timeout() {
      if (!this.loading) {
        await this.$store.dispatch(STORE_PREFIX + 'test/questions/save', this.question.id);

        this.$store.commit(STORE_PREFIX + 'test/questions/set_answered', {
          id: this.question.id,
          v: true
        });

        this.can_save = true;
        this.isTimeout = true;

        if (this.is_last) {
          await this.$emit('timeout');
          this.end_time = true;
        }
      } else {
        this.$store.commit(STORE_PREFIX + 'test/questions/set_answered', {
          id: this.question.id,
          v: true
        });
        this.can_save = true;
        this.isTimeout = true;

        if (this.is_last) {
          this.$emit('timeout');
          this.end_time = true;
        }
      }
    },

    end_question_media() {
      let item = this.questions.filter(i => i.id === this.question_id)[0];
      if (item.media && item.media.is_separate_page) {
        this.load_question();
        this.show_question_content = true;
      }
      this.stop_next = false;
    },

    start_media() {
      this.$store.dispatch(STORE_PREFIX + 'test/question/start_media', this.question_id);
    },

    btn_next() {
      this.stop_next = true;
    },

    stop_timer() {
      this.stop_time = true;
    },

    start_timer() {
      if (this.stop_time) {
        this.stop_time = false;
      }
    },

    // sentryDisplay(data) {
    //   if (this.$raven) {
    //     this.$raven.captureException(new Error('Anticheating-error'), {
    //       extra: data
    //     });
    //   }
    // },

    set_photo(screenshot) {
      if (!(this.loaded || this.showed)) return;
      const data = new FormData();
      data.append('picture', dataURItoBlob(screenshot));
      data.append('response_test_question_id', this.question ? this.question.id : null);
      window.foo = data;
      axios.post(`/public/v2/interviews/${this.token}/test/screenshots`, data);
      if (!screenshot) {
        console.log('screenshot problem');
        // this.sentryDisplay({
        //   videoId: this.videoId,
        //   currentQuestion: this.currentQuestion,
        //   interview: this.interview
        // });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.title {
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  font-size: 18px;
  letter-spacing: 0.005em;
  margin-bottom: 30px;
  word-wrap: break-word;
}
.but {
  display: block;
  min-width: 120px;
  max-width: 375px;
  box-sizing: border-box;
}
.but-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 36px;
}
.timer-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.logo {
  height: 60px;
  max-height: 60px;
  min-height: 60px;
  img {
    height: 100%;
  }
}
.questions_one {
  &.is-blurred {
    filter: blur(15px);
  }

  .question,
  .question_header {
    ::v-deep img {
      width: 100%;
      min-width: 350px;
    }
  }

  ::v-deep {
    .floating-block.timer {
      margin-top: 0;
      margin-bottom: 36px;
    }
  }
}
.text {
  width: 100%;
  margin-bottom: 36px;
  .question_header {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 12px;
  }
  .question_header p {
    margin-top: 0;
  }
  .question_header ol,
  .question_header ul {
    padding-left: 17px;
  }
}

.block-note {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.005em;
  color: #9faab6;
}

.floating-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 460px) {
    display: block;
  }
}

::v-deep {
  // table
  .tableWrapper {
    overflow-x: auto;
  }

  .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;

    tr {
      height: auto !important;
    }

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;
      @include mixin-text-main;

      > * {
        margin-bottom: 0;
      }

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: '';
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }

    p {
      margin: 0;
    }
  }
}
</style>
